<vb-lxp-timing-tower-configurable
	[config]="config"
	[enableColumnCustomization]="enableColumnCustomization()"
	[hideColumnSelection]="hideColumnSelection()"
	[activeClass]="activeClass()"
	[activeNumberClass]="activeNumberClass()"
	[selectedClasses]="selectedClasses()"
/>
